var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('h1',{staticClass:"display-3"},[_vm._v("Logout")]),_c('p',[_vm._v("Signing out...")])])}
var staticRenderFns = []

export { render, staticRenderFns }